<div class="footer">
    <fcdl-footer></fcdl-footer>
</div>